import logoVedix from '../assets/images/brands/logo-Vedix.svg';
import logoCocoSoul from '../assets/images/brands/logo-Coco-Soul.svg';
import logoSetuIndia from '../assets/images/brands/logo-Setu-India.jpg';
import logoSwissBeauty from '../assets/images/brands/logo-Swiss-Beauty.svg';

import brandPrachurya1 from '../assets/images/brands/1.jpg';
import brandPrachurya2 from '../assets/images/brands/2.jpg';
import brandPrachurya3 from '../assets/images/brands/3.jpg';
import brandPrachurya4 from '../assets/images/brands/4.jpg';

export const brandDetails = [
  {
    id: '01_vedix',
    logo: { src: logoVedix, altText: 'Vedix Logo' },
    prachurya: {
      src: brandPrachurya1,
      altText: 'Prachurya with Vedix Product',
    },
    details: `Vedix is India’s only customized Ayurvedic Lifestyle & wellness Regimen. I worked with the brand as a model for the promotional video of their personalized Anti-hair fall kit comprising an Anti-hair fall Shampoo, Anti-hair fall oil, and a hair-regrowth serum.`,
  },
  {
    id: '02_swiss_beauty',
    logo: { src: logoSwissBeauty, altText: 'Swiss Beauty Logo' },
    prachurya: {
      src: brandPrachurya2,
      altText: 'Prachurya with Swiss Beauty Product',
    },
    details: `Swiss Beauty is the world’s fastest-growing beauty brand and has an amazing range of products developed by professionals. I worked with them in a paid partnership to promote their matte-range lipstick collection.`,
  },
  {
    id: '03_setu_india',
    logo: { src: logoSetuIndia, altText: 'Setu India Logo' },
    prachurya: {
      src: brandPrachurya3,
      altText: 'Prachurya with Setu India Product',
    },
    details: `Setu India carries the hallmark of expertise in the universe of dietary supplements. It is one of India’s leading online health supplement stores & promotes a healthier lifestyle. I worked in collaboration with the brand for the promotion of their best-selling Lutein & power-packed Turmerich Gummies.`,
  },
  {
    id: '04_coco_soul',
    logo: { src: logoCocoSoul, altText: 'Coco Soul Logo' },
    prachurya: {
      src: brandPrachurya4,
      altText: 'Prachurya with Coco Soul Product',
    },
    details: `Coco Soul Beauty is a natural Ayurvedic brand that excels because of its authentic Ayurvedic Coconut-based products. I worked with them for Instagram-based social media promotion of their Body lotion & hair conditioner.`,
  },
];
